import { createContext, Dispatch, SetStateAction } from "react";

export type UserAuthenticationContextState = {
  isTransitioning: boolean;
  user?: HydratedAuthenticationUser | null;
  userAccessToken?: UserAccessToken | null;
};

export type UserAuthenticationContextValue = UserAuthenticationContextState & {
  set: Dispatch<SetStateAction<UserAuthenticationContextState>>;
  setUser: (user?: HydratedAuthenticationUser | null) => void;
  setUserAccessToken: (userAccessToken: UserAccessToken | null) => void;
};

export default createContext<UserAuthenticationContextValue>({
  isTransitioning: false,
  set: () => {},
  setUser: () => {},
  setUserAccessToken: () => {},
});
